import React, { Component } from "react";
import { connect } from "@common/components/base.component";
import Fab from "@common/externos/components/fab/fab.externo";
import { Row, Col } from "react-bootstrap";
import api from "../service/obrasParticulares.service";
import Typography from "@material-ui/core/Typography";

class Container extends Component {
  constructor(props) {
    super(props);

    this.state = {
      modulos: []
    };
  }

  async componentDidMount() {
    const response = await api.getModulosAtivosByIdSistema();
    this.setState({ modulos: response.data });
  }

  redirect({ Alias, State: name }) {
    const { routerManager } = this.props;

    routerManager.redirect({ name });
  }

  render() {
    const { modulos } = this.state;

    if (!modulos.length)
      return (
        <div className="text-center text-muted p-5">
          <Typography>Não existem módulos habilitados para Obras Particulares.</Typography>
        </div>
      );

    return (
      <Row>
        {modulos.map((modulo, index) => (
          <Col xs={12} lg={4} key={index}>
            <Fab
              title={modulo.Nome}
              icon={`fas fa-${modulo.Icone}`}
              onClick={() => this.redirect(modulo)}
            />
          </Col>
        ))}
      </Row>
    );
  }
}

export default connect()(Container);
